import { Box, Container, Typography, Divider, Paper } from "@mui/material";
import { theme } from "./theme";
import useTranslationState from "./useTranslationState";

function Imprint() {
    const translations = useTranslationState({
        imprintTitle: 'Imprint',
        companyName: 'Ukoni GmbH',
        representedBy: 'Represented by',
        managingDirector: 'Managing Director',
        address: 'Address',
        addressText: 'Musterstraße 123, 10115 Berlin, Germany',
        phone: 'Phone',
        phoneText: '+49 30 123456789',
        email: 'Email',
        emailText: 'contact@ukoni.com',
        registrationCourt: 'Registration Court',
        registrationNumber: 'Registration Number',
        vatId: 'VAT ID',
        responsibleContent: 'Responsible for content according to § 55 Abs. 2 RStV',
        disclaimer: 'Disclaimer',
        disclaimerText: 'Despite careful content control, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.'
    });

    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: theme.palette.primary.dark,
                paddingY: 12,
                minHeight: '100vh',
            }}
        >
            <Container maxWidth="md">
                <Paper
                    elevation={0}
                    sx={{
                        backgroundColor: 'rgba(255,255,255,0.05)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '16px',
                        padding: { xs: 3, sm: 5 },
                        border: '1px solid rgba(255,255,255,0.1)',
                        opacity: 0,
                        animation: 'fadeIn 0.8s forwards cubic-bezier(0.23, 1, 0.32, 1)',
                        '@keyframes fadeIn': {
                            '0%': {
                                opacity: 0,
                                transform: 'translateY(10px)',
                            },
                            '100%': {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                        },
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            color: 'white',
                            mb: 3,
                            fontWeight: 500,
                            textAlign: 'center',
                        }}
                    >
                        {translations.imprintTitle}
                    </Typography>

                    <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h6" sx={{ color: 'white', mb: 2 }}>
                            {translations.companyName}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            <strong>{translations.representedBy}:</strong> {translations.managingDirector}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            <strong>{translations.address}:</strong> {translations.addressText}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            <strong>{translations.phone}:</strong> {translations.phoneText}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            <strong>{translations.email}:</strong> {translations.emailText}
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            {translations.registrationCourt}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            {translations.registrationNumber}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                mb: 1,
                                lineHeight: 1.8,
                            }}
                        >
                            {translations.vatId}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

                    <Box>
                        <Typography variant="h6" sx={{ color: 'white', mb: 2 }}>
                            {translations.disclaimer}
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                lineHeight: 1.8,
                            }}
                        >
                            {translations.disclaimerText}
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}

export default Imprint; 
